module.exports = __webpack_public_path__ + "static/media/dart-board-selector.8509fe36.png";